module.exports = __webpack_public_path__ + "assets/img/Future_003.e34bed29-ps.jpg";